import React from 'react';
import DocumentToAccept from './DocumentToAccept';
import TermsOfUseInput from './TermsOfUseInput';

const DataProcessingAgreementPendingRequest = ({ dataProcessingAgreementPendingChangeRequest }) => {
  return (
    <>
      {dataProcessingAgreementPendingChangeRequest.map((req) => (
        <div key={req.id}>
          <DocumentToAccept pendingChangeRequest={req} />
          <br />
          <TermsOfUseInput inputName="dataProcessingAgreementStatus" />
        </div>
      ))}
    </>
  );
};

export default DataProcessingAgreementPendingRequest;
